module.exports = __webpack_public_path__ + "fonts/HelveticaNowMicro-Light.bf20a202.woff2";